import { useEffect, useRef } from 'react'
import { getPageYOffset } from './useSmoothScrollbar'
import afterFrame from '../helpers/afterFrame'
import offsetTop from '../helpers/offsetTop'
import { isCurrentBreakpointMobile } from '../redux/slices/layout'
import { useSelector } from 'react-redux'

// Calculate 55dvh dynamically, with SSR safety
const getHeaderOffset = () => {
  if (typeof window === 'undefined') return 0
  // Use document.documentElement.clientHeight for dynamic viewport height (dvh equivalent)
  const dynamicViewportHeight = document.documentElement.clientHeight || window.innerHeight
  return dynamicViewportHeight * 0.73
}

export default (containerRef, contentRef) => {
  const locals = useRef({})
  const isMobile = useSelector(isCurrentBreakpointMobile)

  useEffect(() => {
    if (isMobile) return
    var animationFrame
    const tick = () => {
      const { start, end } = locals.current
      if (contentRef.current && start) {
        const scrollY = getPageYOffset()
        if (scrollY >= start && scrollY <= end) {
          contentRef.current.style.transform = `translate3d(0,${scrollY - start}px,0)`
        }
      }
      afterFrame(() => {
        if (contentRef.current) {
          const headerOffset = getHeaderOffset()
          locals.current = {
            start: offsetTop(containerRef.current) - headerOffset,
            end: offsetTop(containerRef.current) + containerRef.current.offsetHeight - contentRef.current.offsetHeight - headerOffset
          }
        }
      })
      animationFrame = window.requestAnimationFrame(tick)
    }
    animationFrame = window.requestAnimationFrame(tick)
    return () => {
      window.cancelAnimationFrame(animationFrame)
    }
  }, [isMobile])
}
